import { render } from "./RegistrarProductoModal.vue?vue&type=template&id=089ab968&scoped=true"
import script from "./RegistrarProductoModal.vue?vue&type=script&lang=js"
export * from "./RegistrarProductoModal.vue?vue&type=script&lang=js"

import "./RegistrarProductoModal.vue?vue&type=style&index=0&id=089ab968&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-089ab968"]])

export default __exports__